// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"filepicker_thumbnail__1cVaj","tips":"filepicker_tips__3mXK-"};